module.exports = __webpack_public_path__ + "static/media/ful.e9799b60.ogg";